module.exports = __webpack_public_path__ + "media/images/covid/banner/id-7cba126ce429dd2d017d3ddd5f91da72.jpg";